module.exports = __webpack_public_path__ + "img/ring_g_l_1_0@2x.7ff55536.png";